<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 22 18">
    <g clip-path="url(#clip0_6892_8919)">
      <path
        d="M16.8367 0H0.777832V13.2H16.8367V0ZM15.6014 12H2.01313V1.2H15.6014V12ZM21.7778 4.8V18H5.71901V14.364H6.9543V16.8H20.5425V6H18.0472V4.8H21.7778Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_8919">
        <rect width="21" height="18" fill="white" transform="translate(0.777832)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
